<template>
  <div>
    <!-- Common Component -->
    <b-container fluid>
     <BaseObject
        :object="object"
        :isNew="isNew"
        :payloads="basicItems"
        @input="reflectBasicItem"
      />
      <!-- Option components -->
      <!-- usecase_charts -->
      <div>
        <h6 class="text-left">ユースケース図</h6>
        <b-container class="bottom-spacer clearfix">
          <div v-for="(image,index) in basicItems.image_list" :key="image" class>
            <b-img
              v-if="!image.match(/.pdf$/)"
              :src="`/public/${image}`"
              width="150"
              class="usecase_images"
              :id="index +'_'+image"
              @click="displayImage(image)"
              left />
              <v-btn
                icon
                v-else
                class="pdf_btn float-left"
                :href="`/public/${image}`"
                target="_blank"
              >
                <b-img
                  :id="index +'_'+image"
                  class="usecase_pdf_style usecase_images"
                  :src="pdfIcon"
                />
              </v-btn>
             <b-popover
              :target="index +'_'+image"
              placement="top"
              :title="image"
              triggers="hover focus"
              align-h="center"
              boundary="viewport"
            >
              <b-row align-h="center">
                <b-button variant="outline-danger" pill size="sm" @click="removeImage(image)">削除</b-button>
              </b-row>
            </b-popover>
          </div>
        </b-container>
        <b-row align-h="center">
          <b-col sm="8">
            <b-form-file
              v-model="selecting_files"
              small
              placeholder="ファイルを選択してください"
              multiple
              browse-text="画像選択" />
            <b-button @click="putImage">追加</b-button>
          </b-col>
        </b-row>
      </div>
      <!-- built in Component -->
      <ChildList
        :items="basicItems.communication_designs.items"
        :object="object"
        :parent_id="basicItems.no"
        v-if="!this.isNew"
      />
      <!-- Common Component -->
      <b-row align-h="center">
        <template >
          <button type="button" class="btn btn-info button_spacer" v-if="isNew" @click="createUsecase">作成</button>
          <button type="button" class="btn btn-info button_spacer" @click="updateUsecase" v-else>変更</button>
        </template>
        <button
          @click="displayResumeModal = !displayResumeModal"
          class="btn btn-outline-secondary"
        >戻る</button>
      </b-row>
      <b-modal
        v-model="displayImageModal"
        size="xl"
        hide-footer
        hide-header
        scrollable
      >
        <img :src="modalImageUrl">
      </b-modal>
      <b-modal
        v-model="displayResumeModal"
        hide-footer
      >
        <b-row align-h="around">
          <p>移動してよろしいですか？？</p>
        </b-row>
        <b-row align-h="around">
          <router-link
            class="btn btn-outline-secondary"
            to="/"
          >はい</router-link>
          <button
            class="btn btn-outline-secondary"
            @click="displayResumeModal = !displayResumeModal"
          >いいえ</button>
        </b-row>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import BaseObject from '../../common_parts/BaseObject.vue'
import ChildList from '../../common_parts/ChildList.vue'
import pdfIcon from '../../../assets/pdf_icon.png'
import awsconfig from '../../../aws-exports'
import { API, graphqlOperation, Storage } from 'aws-amplify'
import { mapState } from 'vuex'

Storage.configure({
  AWSS3: {
    bucket: awsconfig.aws_content_delivery_bucket,
    region: awsconfig.aws_content_delivery_bucket_region
  }
})
export default {
  name: 'Usecase',
  components: {
    BaseObject,
    ChildList
  },
  data () {
    return {
      object: '',
      isNew: '',
      id: '',
      parent_id: '',
      selecting_files: [],
      basicItems: {
        no: '',
        version: '',
        name: '',
        revision_symbol: '',
        description: '',
        restrictions: '',
        status: '',
        image_list: [],
        communication_designs: {
          items: []
        }
      },
      toast: {},
      displayResumeModal: false,
      displayImageModal: false,
      modalImageUrl: '',
      pdfIcon: pdfIcon,
      vue_app_origin: ''
    }
  },
  computed: {
    ...mapState(['version'])
  },
  async created () {
    this.object = this.$route.path.split('/')[1]
    this.id = this.$route.params.usecaseId
    // fetch basic object
    this.parent_id = this.$route.query.parent_id
    if (this.id) {
      this.isNew = false
      const func = await API.graphql(graphqlOperation(`
        query getUsecase {
          getUsecase(no: ${this.id}, version: "${this.version}"){
            no
            version
            name
            revision_symbol
            description
            restrictions
            image_list
            communication_designs {
              items {
                no
                name
              }
            }
          }
        }
      `))
      // to check query result
      if (func.data.getUsecase) {
        this.basicItems = { ...func.data.getUsecase }
      } else {
        this.$router.push('/' + this.object)
      }
    } else {
      this.isNew = true
      // checking parrent_id exsit on url
      if (!this.$route.query.parent_id) {
        this.makeToast('parent_id', 'parent_idが指定されていません。', 'danger')
        setTimeout(function () {
          this.$router.go(-1)
        }.bind(this), 2000)
      }
      // checking parent_id is Integer
      if (!parseInt(this.$route.query.parent_id)) {
        this.makeToast('parent_id', '無効なparent_idです。', 'danger')
        setTimeout(function () {
          this.$router.go(-1)
        }.bind(this), 2000)
      }
    }
    this.vue_app_origin = process.env.VUE_APP_ORIGIN
  },
  methods: {
    reflectBasicItem (event) {
      this.basicItems = { ...event }
    },
    async putImage () {
      const fileName = this.selecting_files[0].name
      if (this.basicItems.image_list.length > 15) {
        this.makeToast('失敗', '16枚までしかアップロードできません。', 'danger')
        return
      }
      if (this.basicItems.image_list.includes(fileName)) {
        this.makeToast('失敗', '同名のファイルが登録されています。', 'danger')
        return
      }
      try {
        const s3key = `${this.version}/${this.object}/${this.basicItems.no}/${fileName}`
        this.$log.debug(s3key)
        const result = await Storage.put(s3key, this.selecting_files[0], {
          contentType: this.selecting_files[0].type
        })
        this.basicItems.image_list.push(s3key)
        this.$log.debug(result)
        this.makeToast('成功', '画像のアップロードに成功しました', 'info')
      } catch (e) {
        this.$log.debug(e)
        this.makeToast('失敗', '画像のアップロードに失敗しました', 'danger')
      }
    },
    async removeImage (fileName) {
      try {
        await Storage.remove(fileName)
        this.basicItems.image_list.splice(this.basicItems.image_list.indexOf(fileName), 1)
        this.updateUsecaseWithoutRefresh()
        this.makeToast('成功', '画像の削除に成功しました。', 'info')
      } catch {
        this.makeToast('失敗', '画像の削除に失敗しました。', 'danger')
      }
    },
    async updateUsecase () {
      try {
        let requestBody = ''
        requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}\n`
        requestBody += this.version === '' ? '' : `version: "${this.version}"\n`
        requestBody += this.basicItems.revision_symbol === '' || this.basicItems.revision_symbol === null ? 'revision_symbol: null\n' : `revision_symbol: "${this.basicItems.revision_symbol}"\n`
        requestBody += this.basicItems.name === '' ? '' : `name: "${this.basicItems.name}"\n`
        requestBody += this.basicItems.description === '' || this.basicItems.description === null ? 'description: null\n' : `description: "${this.basicItems.description.replace(/\r?\n/g, '\\n')}"\n`
        requestBody += this.basicItems.restrictions === '' || this.basicItems.restrictions === null ? 'restrictions: null\n' : `restrictions: "${this.basicItems.restrictions.replace(/\r?\n/g, '\\n')}"\n`
        const updateRequest = `mutation updateUsecase {
          updateUsecase(input:{
            ${requestBody}
            image_list: [${this.basicItems.image_list.map(function (elm) { return '"' + elm + '"' })}]
          }){
            no
            version
            name
            revision_symbol
            description
            restrictions
          }
        }`
        this.$log.debug('=====Usecase Update Input=====', updateRequest)
        const response = await API.graphql(graphqlOperation(updateRequest))
        this.makeToast('正常終了', `${this.translate[this.object]}更新が完了しました。`, 'info')
        this.$log.debug('=====Usecase Update Success=====', response)
        this.$router.go()
      } catch (e) {
        this.makeToast('エラー', `${this.translate[this.object]}更新中にエラーが発生しました。`, 'danger')
        this.$log.debug('=====Usecase Update Error=====', e)
      }
    },
    async createUsecase () {
      try {
        let requestBody = ''
        requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}\n`
        requestBody += this.version === '' ? '' : `version: "${this.version}"\n`
        requestBody += this.basicItems.revision_symbol === '' || this.basicItems.revision_symbol === null ? '' : `revision_symbol: "${this.basicItems.revision_symbol}"\n`
        requestBody += this.basicItems.name === '' ? '' : `name: "${this.basicItems.name}"\n`
        requestBody += this.basicItems.description === '' || this.basicItems.description === null ? 'description: null\n' : `description: "${this.basicItems.description.replace(/\r?\n/g, '\\n')}"\n`
        requestBody += this.basicItems.restrictions === '' || this.basicItems.restrictions === null ? 'restrictions: null\n' : `restrictions: "${this.basicItems.restrictions.replace(/\r?\n/g, '\\n')}"\n`
        const createRequest = `mutation createUsecase {
          createUsecase(input:{
            ${requestBody}
            image_list: [${this.basicItems.image_list.map(function (elm) { return '"' + elm + '"' })}]
            system_function_no: ${this.parent_id}
          }){
            no
            version
            name
            revision_symbol
            description
            restrictions
          }
        }`
        this.$log.debug('=====Usecase Create Input=====', createRequest)
        const response = await API.graphql(graphqlOperation(createRequest))
        this.makeToast('正常終了', `${this.translate[this.object]}作成が完了しました。`, 'info')
        this.$log.debug('=====Usecase Create=====', response)
        await this.$router.push(`/usecase/${response.data.createUsecase.no}`)
        this.$router.go()
      } catch (e) {
        this.$log.debug('=====Usecase Create Error=====', e)
        const isConditionalError = e.errors.some(
          function (elm) {
            return elm.message.includes('ConditionalCheckFailedException')
          }
        )
        if (isConditionalError) {
          this.makeToast('失敗', `作成に失敗しました。\nNoが重複していないかご確認ください。`, 'danger')
        } else {
          this.makeToast('失敗', '作成に失敗しました。\n必須項目の入力漏れがないかご確認ください。', 'danger')
        }
      }
    },
    async updateUsecaseWithoutRefresh () {
      try {
        let requestBody = ''
        requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}\n`
        requestBody += this.version === '' ? '' : `version: "${this.version}"\n`
        const updateRequest = `mutation updateUsecase {
          updateUsecase(input:{
            ${requestBody}
            image_list: [${this.basicItems.image_list.map(function (elm) { return '"' + elm + '"' })}]
          }){
            no
            version
          }
        }`
        this.$log.debug('=====Usecase Update Input=====', updateRequest)
        const response = await API.graphql(graphqlOperation(updateRequest))
        this.$log.debug('=====Usecase Update Success=====', response)
      } catch (e) {
        this.makeToast('エラー', `${this.translate[this.object]}更新中にエラーが発生しました。`, 'danger')
        this.$log.debug('=====Usecase Update Error=====', e)
      }
    },
    displayImage (image) {
      this.displayImageModal = true
      this.modalImageUrl = `https://communication-design.cloud-partner.site/public/${image}`
    }
  }
}
</script>
<style>
  .usecase_images {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .bottom-spacer {
    margin-bottom: 1rem;
  }
  .usecase_pdf_style {
    width: 60px;
  }
  .pdf_btn {
    margin: 15px 10px 20px ;
  }
</style>
